import gql from 'graphql-tag'

export const QUERY_HOTSITE_SLOTS = gql`
  query HotsiteSlots {
    hotsiteSlots(page: 1, pageSize: 1000) {
      records
      page
      slots {
        _id
        name
        urls
        latest_version
      }
    }
  }
`
